import { PackageManager } from '../types';

export class PackageManagerResolver {
	static getListCommand(
		manager: PackageManager,
		productionOnly: boolean,
	): string {
		const baseCommand =
			manager === PackageManager.PNPM ? 'pnpm ls --json' : 'npm ls --json';
		const prodFlag = this.getProductionFlag(manager);
		return productionOnly ? `${baseCommand} ${prodFlag}` : baseCommand;
	}

	private static getProductionFlag(manager: PackageManager): string {
		return [PackageManager.PNPM, PackageManager.YARN].includes(manager)
			? '--prod'
			: '--omit=dev';
	}
}
